/**
 * Decide whether drawer children should remount (new contentKey).
 * Remount when content changes so previews/etc. do not go stale.
 * Do NOT remount on width-only updates (alterSiteDrawerWidth) — that wipes
 * nested drawer state (e.g. automation multi-sender rules picker).
 *
 * @param {{ wantsOpen: boolean, nextContent: unknown, prevContent: unknown }} opts
 * @returns {boolean}
 */
function shouldRemountDrawerContent({ wantsOpen, nextContent, prevContent }) {
    if (!wantsOpen) return false
    return nextContent !== prevContent
}

module.exports = {
    shouldRemountDrawerContent
}
